import { gql } from '@apollo/client';

export default gql`
  query getToasts {
    toasts @client {
      message
      severity
    }
  }
`;
